const state = {
  headerHeight: 0,
  newlineRegex: /(?:\n|\r|\r\n)+/,
  scale: 1,
  zoom: 0,
  zoomStep: 1.2,
  rootLoadingMessage: '',
  rootLoadingMessageResetTimer: '',
  disableForcedLandscape: false,
  disableAutoplay: false,
};

const mutations = {
  setHeaderHeight(state, { headerHeight = 0 }) { state.headerHeight = headerHeight; },
  setScale(state, { scale = 1 }) { state.scale = scale; },
  setZoom(state, { zoom = 0 }) { state.zoom = zoom; },
  setRootLoadingMessage(state, data) {
    if (data && state.rootLoadingMessageResetTimer) {
      clearTimeout(state.rootLoadingMessageResetTimer);
    }
    state.rootLoadingMessage = data;
  },
  setRootLoadingMessageResetTimer(state, data) {
    state.rootLoadingMessageResetTimer = setTimeout(() => {
      state.rootLoadingMessage = '';
    }, data);
  },
  setDisableForcedLandscape(state, data) {
    state.disableForcedLandscape = data;
  },
  setDisableAutoplay(state, data) {
    state.disableAutoplay = data;
  },
};

const actions = {
  setHeaderHeight({ commit }, { headerHeight = 0 }) {
    commit('setHeaderHeight', { headerHeight });
  },
  setScale({ commit }, { scale = 1 }) {
    commit('setScale', { scale });
  },
  setZoom({ commit }, { zoom = 0 }) {
    commit('setZoom', { zoom });
  },
  scrollToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  zoomIn({ commit, getters }) {
    const zoom = getters.zoom + 1;
    commit('setZoom', { zoom });
  },
  zoomOut({ commit, getters }) {
    const zoom = getters.zoom - 1;
    commit('setZoom', { zoom });
  },
};

const getters = {
  headerHeight({ headerHeight }) { return headerHeight; },
  newlineRegex({ newlineRegex }) { return newlineRegex; },
  scale({ scale }) { return scale; },
  zoom({ zoom }) { return zoom; },
  zoomStep({ zoomStep }) { return zoomStep; },
  rootLoadingMessage({ rootLoadingMessage }) { return rootLoadingMessage; },
  disableForcedLandscape({ disableForcedLandscape }) { return disableForcedLandscape; },
  disableAutoplay({ disableAutoplay }) { return disableAutoplay; },
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/display/display.js